export { sortable } from './sortable';



// WEBPACK FOOTER //
// ./src/packages/@ncigdc/uikit/Sortable/index.js